import { ClusterType } from '../../clustering.types';
import { useClassificationColor } from '../../hooks/useClassificationColor';
import { Tag } from '@cdl/heartbeat-react';

interface Props {
  classification: ClusterType;
}

export const ClassificationLabel: React.FC<Props> = ({ classification }) => {
  const classificationColor = useClassificationColor();
  return (
    <Tag
      position='absolute'
      bottom='s'
      right='s'
      colorScheme={classificationColor(classification)}
      data-testid='classification-label'
      size='sm'
    >
      {classification}
    </Tag>
  );
};
